module.exports = __webpack_public_path__ + "images/sapces-img-mobile.73e834c567751c4c886abe75de9c8cfc.png";